import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";
import React, { useEffect, useRef } from "react";
import { Input } from "semantic-ui-react";

interface RowTypeProps {
  value: server.dto.TimetableEntryType
  onChange: (type: server.dto.TimetableEntryType) => void

  dropdownError: boolean
  emptyCustomNameError: boolean
}

const RowType = (props: RowTypeProps) => {
  const ref = useRef<Input>(null);

  useEffect(() => {
    if (props.value.value === "custom") {
      if (ref.current) {
        ref.current.focus();
      }
    }
  }, [props.value.value]);

  const customOption: server.dto.TimetableEntryType = { value: "custom", text: RESX.GeneralLabels.CustomValue };

  return <>
    <BaseReactSelectDropdown<server.dto.TimetableEntryType, false, server.dto.TimetableEntryTypes>
      options={[
        ...serverReference.timetableEntryTypes,
        customOption
      ]}
      getLabel={type => type.text}
      getValue={type => type.value}
      excludeKeys={[]}
      value={props.value.value === "custom" ? customOption : props.value}
      onChange={v => {
        if (v.value === "custom") props.onChange({ value: "custom", text: "" });
        else props.onChange(v);
      }}
      config={{
        isSearchable: true,
        hasError: props.dropdownError
      }}
    />

    {props.value.value === "custom" &&
      <div className="margin-top-small">
        <Input
          ref={ref}
          error={props.emptyCustomNameError}
          value={props.value.text || ""}
          onChange={(_, { value }) => { props.onChange({ value: props.value.value, text: value.substring(0, serverReference.constants.timetable.maxCustomNameLength) }); }}
          fluid
        />
      </div>}
  </>;
};

export default RowType;